import { Injectable } from '@angular/core';
import { Mappings } from '../../shared/mapping';
import { ApiService } from '../core/api.service';

@Injectable()
export class CurrencyService {
    constructor
        (
            public _api: ApiService,
            private mappings: Mappings
        ) { }

    private currencyVal: string = "";

    getCurrency() {
        let param = '$';

        switch (param) {
            case '$': return 'USD';
            case '€': return 'EUR';
            default: return 'EUR';
        }
    }
    getCurrencyBackend() {
        let url = this.mappings.Web_Api_Get_DefaultCurrency
        return this._api.get(url);
    }
    
    getDefaultCurrency() {
       return this.currencyVal;
    }

    setDefaultCurrency(currency:string)
    {
        this.currencyVal=currency;
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/currency.service.ts